<template>
  <div></div>
</template>

<script>
import { mapState } from 'vuex'
import {setFirstInputDone} from '../utils'

export default {
  name: 'Undo',
  computed: {
    ...mapState(['session', 'refreshSessionOnUndo'])
  },
  created() {
    this.$store.commit('busy')
    if (this.refreshSessionOnUndo) {
      this.$store.commit('refresh_session_on_undo', false)
      history.back()
      let _this = this
      setTimeout(() => {
        if (_this.session && _this.session.can_go_home) {
          history.pushState(null, null, '/undo')
          history.pushState(null, null, '/session')
        } else {
          setFirstInputDone(false)
        }
      }, 100)
      return
    }
    if (this.session && this.session.can_go_home) {
      this.$store.dispatch('undo')
        .then(session => {
          this.$store.commit('clear_messages')
          this.$store.commit('increment_undo_count')
          history.back()
          this.$store.commit('ready')
          let _this = this
          setTimeout(() => {
            if (_this.session && _this.session.can_go_home) {
              history.pushState(null, null, '/undo')
              history.pushState(null, null, '/session')
            } else {
              setFirstInputDone(false)
            }
          }, 100)
        })
        .catch(err => {
          console.log(err)
          this.$store.commit('ready')
          history.back()
        })
    } else {
      if (this.session && this.session.can_enter_exit_lifeline) {
        this.$store.commit('force_loader_display', true)
        this.$store.commit('busy')
        this.$store.commit('exit_popup')
        this.$router.replace({name: 'session'})
      } else {
        //  if there is no exit lifeline configured just pop the remaining history and let the user go
        history.back()
        //  go to the undo route in the history if available so that we can pop the remaining history out
        history.back()
      }
    }
  }
}
</script>

<style scoped>

</style>
